import { FC } from 'react'
import PageLayout from '../../../components/page-layout/page-layout'
import TableWrapper from '../../../components/table-wrapper/table-wrapper'
import { Table } from 'antd'
import { columns } from './constants/columns'
import { useGetRollersWithStampsCountQuery } from '../../../store/api/rollers-api'
import RollerWithStampsCount from '../../../types/api/roller-with-stamps-count'

interface RollersPageProps {}

const RollersPage: FC<RollersPageProps> = () => {
    const { data } = useGetRollersWithStampsCountQuery()

    const dataSource: RollerWithStampsCount[] = data || []

    return (
        <PageLayout title={'Валы'}>
            <TableWrapper style={{ flex: 'auto' }}>
                <Table
                    bordered
                    columns={columns}
                    dataSource={dataSource}
                    rowKey={record => record.id}
                    summary={data => {
                        return (
                            <Table.Summary>
                                <Table.Summary.Row>
                                    <Table.Summary.Cell index={1}>
                                        <b>{data.length} шт.</b>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell index={2}></Table.Summary.Cell>
                                    <Table.Summary.Cell index={3}>
                                        <b>
                                            {data.reduce((sum, cur) => sum + cur.stamps_count, 0)}{' '}
                                            шт.
                                        </b>
                                    </Table.Summary.Cell>
                                </Table.Summary.Row>
                            </Table.Summary>
                        )
                    }}
                    pagination={false}
                />
            </TableWrapper>
        </PageLayout>
    )
}

export default RollersPage
